"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetAnimTrigger = exports.LoadUnity = void 0;
var UnityInstance = null;
function LoadUnity(canvas) {
    return __awaiter(this, void 0, void 0, function* () {
        const folderName = "UnityModel/Build/UnityModel";
        const config = {
            dataUrl: folderName + `.data.unityweb`,
            frameworkUrl: folderName + `.framework.js.unityweb`,
            codeUrl: folderName + `.wasm.unityweb`,
            streamingAssetsUrl: folderName + "UnityModel/StreamingAssets",
            companyName: "BCIT",
            productName: "Hematology Analyzer",
            productVersion: "0.1",
        };
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "UnityModel/Build/UnityModel.loader.js";
        script.onload = () => {
            if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
                // Mobile device style: fill the whole browser client area with the game canvas:
                var meta = document.createElement("meta");
                meta.name = "viewport";
                meta.content =
                    "width=device-width, height=device-height, initial-scale=1.0, user-scalable=no, shrink-to-fit=yes";
                document.getElementsByTagName("head")[0].appendChild(meta);
            }
            window.createUnityInstance(canvas, config, (progress) => {
                console.log("Unity Progress: ", progress);
            })
                .then((unityInstance) => {
                UnityInstance = unityInstance;
            })
                .catch((message) => {
                console.log(message);
            });
        };
        document.body.appendChild(script);
    });
}
exports.LoadUnity = LoadUnity;
function SetAnimTrigger(btnid) {
    let trigger;
    switch (btnid) {
        case 'runqc-btn':
            trigger = "qc";
            break;
        case 'runpa-btn':
            trigger = "batch";
            break;
        case 'runma-btn':
            trigger = "manual";
            break;
        case 'reset-btn':
            trigger = "reset";
            break;
        default:
            throw new Error("Invalid button id");
    }
    UnityInstance.SendMessage("Hematology Analyzer", "SetParam", "reset,1");
    UnityInstance.SendMessage("Hematology Analyzer", "SetParam", trigger + ",1");
}
exports.SetAnimTrigger = SetAnimTrigger;
